import React, { Fragment } from "react";
import { Container, List, Segment, Grid, Header } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import { FrontendVersion } from "./versions";
import { Email, Twitter, Facebook, Youtube, Address } from "../social";
import { Link } from "gatsby";
import { I18Link } from "../i18link";
import { Flag } from "../flag";

const footerLinks = (siteMapPerId, locale) => {
  const safeRetrieve = (key) =>
    siteMapPerId[key]
      ? siteMapPerId[key][locale]
        ? siteMapPerId[key][locale]
        : { text: key }
      : { text: key };

  if (siteMapPerId && locale) {
    return [
      safeRetrieve("index"),
      safeRetrieve("features"),
      safeRetrieve("pricing"),
      safeRetrieve("volume-discount"),
      safeRetrieve("download"),
      safeRetrieve("support"),
      safeRetrieve("company"),
      safeRetrieve("translation"),
      safeRetrieve("software-license-agreement"),
      safeRetrieve("third-parties"),
      safeRetrieve("privacy-policy"),
      safeRetrieve("affiliate-program"),
    ];
  } else {
    return [];
  }
};

const SiteMapComponent = ({ siteMapPerId, locale }) => {
  if (siteMapPerId && locale) {
    const links = footerLinks(siteMapPerId, locale);

    return (
      <Fragment>
        <Header
          inverted
          as="span"
          style={{ display: "block", fontSize: "15px" }}
          content={<FormattedMessage id="footer.site" />}
        />
        <List link inverted role="contentinfo">
          {links.map((s, index) => (
            <Link
              className="item"
              to={s.path}
              key={`footer_site_map_link_${index}`}
            >
              {s.text}
            </Link>
          ))}
        </List>
      </Fragment>
    );
  } else {
    return null;
  }
};

const AddressComponent = ({ compact }) => (
  <Fragment>
    <Header
      inverted
      as="span"
      style={{ display: "block", fontSize: "15px" }}
      content={<FormattedMessage id="footer.contact-us" />}
    />
    <p>
      <Address />
    </p>

    <List link inverted role="contentinfo">
      <Email icon={!compact} className="item" />
    </List>
  </Fragment>
);

const RecentPosts = ({ releases }) => (
  <Fragment>
    <Header as="span" style={{ display: "block", fontSize: "15px" }} inverted>
      <FormattedMessage id="footer.recent-releases" />
    </Header>
    <List link inverted role="contentinfo">
      {releases.map((release, index) => (
        <List.Item
          role="link"
          key={`release_${index}`}
          as={I18Link}
          id={release.node.fields.id}
        >
          {release.node.frontmatter.title}
        </List.Item>
      ))}

      <List.Item
          role="link"
          key={`release_all`}
          as={I18Link}
          id={"releases"}
        >
          <FormattedMessage id="footer.all-releases" /> 
        </List.Item>

    </List>
  </Fragment>
);

const Socials = () => (
  <Fragment>
    <Header
      inverted
      as="span"
      style={{ display: "block", fontSize: "15px" }}
      content={<FormattedMessage id="footer.social-networks" />}
    />
    <List link inverted role="contentinfo">
      <Twitter className="item" />
      <Facebook className="item" />
      <Youtube dark className="item" />
    </List>
  </Fragment>
);

const Locales = ({ locales }) => (
  <Fragment>
    <Header
      inverted
      as="span"
      style={{ display: "block", fontSize: "15px" }}
      content={<FormattedMessage id="footer.languages" />}
    />
    <List link inverted horizontal role="contentinfo">
      {locales &&
        locales.map((item, index) => (
          <Link
            className="item"
            to={item.path}
            key={`lang_selector_${index}`}
            onClick={() => window.localStorage.setItem("language", item.locale)}
          >
            <Flag locale={item.locale} title />
          </Link>
        ))}
    </List>
  </Fragment>
);

export const Footer = ({ siteMeta, locales, siteMap, locale, releases }) => (
  <Fragment>
    <Segment
      inverted
      vertical
      style={{ padding: "5em 0em 5em 0em", background: "#444444" }}
    >
      <Container>
        <Grid divided inverted id="footer-grid">
          <Grid.Row className="mobile hidden">
            <Grid.Column width={4}>
              <Locales locales={locales} />
              <SiteMapComponent siteMapPerId={siteMap} locale={locale} />
            </Grid.Column>
            <Grid.Column width={4}>
              <RecentPosts releases={releases} />
            </Grid.Column>
            <Grid.Column width={4}>
              <Socials />
            </Grid.Column>
            <Grid.Column width={4}>
              <AddressComponent />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="mobile only">
            <Grid.Column width={8}>
              <Locales locales={locales} />
              <SiteMapComponent siteMapPerId={siteMap} locale={locale} />
              <RecentPosts releases={releases} />
            </Grid.Column>
            <Grid.Column width={8}>
              <AddressComponent compact />
              <Socials />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
    <Segment
      basic
      textAlign="center"
      vertical
      inverted
      style={{
        padding: "1em 0em 1em 0em",
        background: "#222222",
      }}
    >
      <FrontendVersion version={siteMeta.version} />
    </Segment>
  </Fragment>
);
